var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuppliers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.944,
    height: 15,
    viewBox: "0 0 15.944 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M7.529-4.687a.459.459,0,0,1,.352.161A.431.431,0,0,1,8-4.16,6.915,6.915,0,0,1,5.859-.029a.5.5,0,0,1-.322.117.39.39,0,0,1-.322-.146L.557-4.687ZM5.537-1.055a6.23,6.23,0,0,0,1.436-2.7H2.842ZM-1.377-4.687l4.57,4.57a.451.451,0,0,1,.132.366.416.416,0,0,1-.19.337A6.788,6.788,0,0,1-.82,1.875H-.908A6.808,6.808,0,0,1-5.771-.117a6.721,6.721,0,0,1-2.168-4.8,7.252,7.252,0,0,1,.41-2.593A6.767,6.767,0,0,1-6.284-9.7a7.214,7.214,0,0,1,1.948-1.582A6.768,6.768,0,0,1-1.9-12.1a.084.084,0,0,1,.059-.029.433.433,0,0,1,.337.146.507.507,0,0,1,.132.352ZM-.82.938a5.908,5.908,0,0,0,2.93-.82l-4.16-4.131-.264-.293v-6.768A5.918,5.918,0,0,0-5.742-8.862,5.969,5.969,0,0,0-7-4.951,5.89,5.89,0,0,0-5.112-.806,5.857,5.857,0,0,0-.908.938ZM7.061-6.592a.507.507,0,0,1-.132.352.433.433,0,0,1-.337.146H.029v-6.562a.472.472,0,0,1,.132-.322A.433.433,0,0,1,.5-13.125H.527A6.8,6.8,0,0,1,5.01-11.074,6.8,6.8,0,0,1,7.061-6.592ZM.967-7.031h5.1a5.906,5.906,0,0,0-1.714-3.384A5.906,5.906,0,0,0,.967-12.129Z",
    transform: "translate(7.941 13.125)",
    fill: "#7f7f7f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuppliers);
export default __webpack_public_path__ + "static/media/suppliers.cb8e878cc80e7e3c6971a4acdf9168b0.svg";
export { ForwardRef as ReactComponent };